import Module from '../utils/Module';
import PopupModule from "./PopupModule";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class ContactModule extends Module {
  constructor(options) {
    super(options);

    this.popup = new PopupModule(options);
    this.DOMEl = options.element;

    this.viewMoreButtons = this.DOMEl.querySelectorAll('.contact-card, .conversion-banner-card');

    this.popupCloseButtons = this.DOMEl.querySelectorAll('.popup-close-button');
    this.bgPopups = this.DOMEl.querySelectorAll('.bg-popup');
    this.formItem = this.DOMEl.querySelectorAll('.form-item');
    this.btnSubmit = this.DOMEl.querySelectorAll('.webform-button--submit');
    this.form = this.DOMEl.querySelectorAll('form');
    this.selects = this.DOMEl.querySelectorAll('select:not(.js-webform-select2)');
    this.consent = this.DOMEl.querySelectorAll('.form-item .description');

    this.accordionsParagraphs = document.querySelectorAll(".accordion-paragraph");

    this.timeline = gsap.timeline().pause();

    jQuery(document).ajaxComplete(function(event, xhr, settings) {
      this.loadForm();
    }.bind(this));

    this.init();
  }

  init() {

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const p = urlParams.get('p');
    if (p != null) {
      const closestParentInfosContainer = this.viewMoreButtons[p - 1].closest(".contact-module, .conversion-banner-module");
      this.popup.openPopup(closestParentInfosContainer);
      this.accordionsParagraphs.forEach(accordion => {
        if (accordion.classList.contains("accordion-paragraph--expanded")) {
          const expandedHeight = accordion.querySelector(".accordion-paragraph__wrapper").getBoundingClientRect().height;
          accordion.style.maxHeight = `${expandedHeight}px`;
        } else {
          const titleHeight = accordion.querySelector(".title").getBoundingClientRect().height;
          accordion.style.maxHeight = `${titleHeight}px`;
        }

      });
      this.trackClick(p);
    }

    this.viewMoreButtons.forEach((button, index) => {
      const closestParentInfosContainer = button.closest(".contact-module, .conversion-banner-module");
      button.addEventListener('click', () => {
        this.popup.openPopup(closestParentInfosContainer);

        this.accordionsParagraphs.forEach(accordion => {
          if (accordion.classList.contains("accordion-paragraph--expanded")) {
            accordion.classList.remove("accordion-paragraph--expanded")
          }
            const titleHeight = accordion.querySelector(".title").getBoundingClientRect().height;
            accordion.style.maxHeight = `${titleHeight}px`;

        });

        this.trackClick(index);
      })
    });

    this.popupCloseButtons.forEach(button => {
      const closestParentInfosContainer = button.closest(".contact-module, .conversion-banner-module");
      button.addEventListener('click', () => {
        this.popup.closePopup(closestParentInfosContainer);
        this.backToForm(closestParentInfosContainer);
      });
    });

    this.bgPopups.forEach(button => {
      const closestParentInfosContainer = button.closest(".contact-module, .conversion-banner-module");
      button.addEventListener('click', () => {
        this.popup.closePopup(closestParentInfosContainer);
        this.backToForm(closestParentInfosContainer);
      });
    });

    this.loadForm();
  }

  backToForm(parentInfoContainer) {
    const popup = parentInfoContainer.querySelector(".popup");
    if (popup.getAttribute('data-webform-id')) {
      const backToForm = popup.querySelector('.js-webform-confirmation-back-link-ajax');
      if (backToForm) {
        backToForm.click();
      }
    }
  }

  reloadForm(parentInfoContainer, event = null) {
    const popup = parentInfoContainer.querySelector(".popup");
    const inst = this;
    if (popup.getAttribute('data-webform-id')) {
      setTimeout(function () {
        const backToForm = popup.querySelector('.js-webform-confirmation-back-link-ajax');
        if (backToForm) {
          backToForm.addEventListener('click', () => {
            setTimeout(function () {
              inst.loadForm();
            }, 1000);
          });
        }
      }, 1000);
    }
  }

  loadForm() {
    this.formItem = this.DOMEl.querySelectorAll('.form-item');
    this.btnSubmit = this.DOMEl.querySelectorAll('.webform-button--submit');
    this.form = this.DOMEl.querySelectorAll('form');
    this.selects = this.DOMEl.querySelectorAll('select:not(.js-webform-select2)');
    this.consent = this.DOMEl.querySelectorAll('.form-item .description');

    this.consent.forEach(check => {
      check.addEventListener('click', () => {
        check.parentElement.querySelector('input').click();
      });
    });

    this.selects.forEach(select => {
      var numberOfOptions = select.childElementCount;

      select.classList.add('select-hidden');
      var divSelect = document.createElement('div');
      divSelect.classList.add('select');
      this.wrap(select, divSelect);

      var divSelectStyled = document.createElement('div');
      divSelectStyled.classList.add('select-styled');
      divSelect.appendChild(divSelectStyled);

      var styledSelect = select.parentNode.querySelector('div.select-styled');
      styledSelect.innerText = select[0].innerText;

      var list = document.createElement('ul');
      list.classList.add('select-options');
      styledSelect.parentNode.insertBefore(list, styledSelect.nextSibling);
      //styledSelect.appendChild(list);

      for (var i = 0; i < numberOfOptions; i++) {
        var li = document.createElement('li');
        li.innerText = select[i].innerText;
        li.setAttribute("rel", select[i].value);
        list.appendChild(li);
      }

      var listItems = list.querySelectorAll('li');

      listItems.forEach(item => {
        item.addEventListener('click', () => {
          styledSelect.innerText = item.innerText;
          styledSelect.classList.remove('active');
          for (var opt, j = 0; opt = select[j]; j++) {
            if (opt.value == item.getAttribute("rel")) {
              select[j].selected = true;
              select.selectedIndex = j;
              break;
            }
          }
          list.classList.remove('active');
          gsap.delayedCall(0.3, () => {
            list.style.display = 'none';
          })
        })
      });

      select.parentNode.querySelector('ul').addEventListener('click', this.trackFillField.bind(this, select), { once: true });

      styledSelect.addEventListener('click', () => {
        var selects = styledSelect.closest("form").querySelectorAll('div.select-styled.active');
        selects.forEach(select => {
          if (select != styledSelect) {
            select.classList.remove('active');
            list.classList.remove('active');
            gsap.delayedCall(0.3, () => {
              select.nextElementSibling.style.display = 'none';
            });

          }
        });

        if (styledSelect.classList.contains('active')) {
          styledSelect.classList.remove('active');
          list.classList.remove('active');
        } else {
          styledSelect.classList.add('active');
          list.classList.add('active');
        }

        if (styledSelect.nextElementSibling.style.display == 'block') {
          gsap.delayedCall(0.3, () => {
            styledSelect.nextElementSibling.style.display = 'none'
          })
        } else {
          styledSelect.nextElementSibling.style.display = 'block'


        }
      });
      this.DOMEl.addEventListener('click', (e) => {
        if (e.target != styledSelect) {
          styledSelect.classList.remove('active');
          list.classList.remove('active');
          gsap.delayedCall(0.3, () => {
            styledSelect.nextElementSibling.style.display = 'none'
          });

        }
      });
    });


    this.btnSubmit.forEach(button => {
      button.innerHTML = "<span>" + button.innerText + "</span>"
      button.disabled = true;
      button.addEventListener('click', (e) => {
        const closestParentInfosContainer = button.closest(".contact-module, .conversion-banner-module");
        this.reloadForm(closestParentInfosContainer);
      });
    });

    this.formItem.forEach(item => {
      if (item.querySelectorAll('input[type="text"].required,input[type="email"].required,textarea.required').length > 0) {
        var required = document.createElement("small");
        required.innerHTML = (window.location.href.indexOf("/fr/") > -1 ? 'Requis' : 'Required' );

        item.appendChild(required);
        var requiredInput = item.querySelector('input[type="text"],input[type="email"],textarea');
        if (requiredInput) {
          requiredInput.addEventListener("focusout", () => {
            if (requiredInput.value == "") {
              item.classList.add("error");
              item.closest("form").querySelector('button.form-submit').disabled = true;
            } else {
              if (input.classList.contains('form-email')) {
                var email = input.value;
                this.validateEmail(email, item);
              } else {
                item.classList.remove("error");
              }
            }
          });
        }
      }

      var input = item.querySelector('input[type="text"],input[type="email"],textarea');
      if (input) {
        input.addEventListener('focus', () => {
          this.checkForCompletedItems();
          item.classList.add("focus");
        });

        input.addEventListener('keypress', this.trackFillField.bind(this, input), { once: true });
      }

      if (item.classList.contains('webform-type-checkboxes')) {
        item.addEventListener('change', this.trackFillField.bind(this, item), { once: true });
      }
    });

    this.checkForCompletedItems();

    this.form.forEach(form => {
      Drupal.attachBehaviors(form.closest('.popup'));
    });
  }

  wrap(el, wrapper) {
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  }

  validateEmail(email, item) {
    var invalidEmail = item.querySelector('small.email');
    if (invalidEmail) {
      invalidEmail.style.display = 'block';
    } else {
      invalidEmail = document.createElement("small");
      invalidEmail.innerHTML = 'Email is not valid';
      invalidEmail.classList.add('email');
      item.appendChild(invalidEmail);
      invalidEmail.style.display = 'none';
    }

    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (re.test(String(email).toLowerCase())) {
      item.classList.remove("error");
      invalidEmail.style.display = 'none';
    } else {
      item.classList.add("error");
      invalidEmail.style.display = 'block';
    }
  }

  trackClick(index) {
    const actions = ["contact us - business", "contact us - media", "join us"];
    dataLayer.push({
      "event": "contentInteraction",
      "interaction": {
        "category": "content interaction",
        "action": actions[index],
        "label": window.location.href
      }
    });
  }

  trackFillField(input) {
    let category = '';
    if (input.closest('form[id*="contact-business"]')) {
      category = 'contact business';
    } else if (input.closest('form[id*="contact-media"]')) {
      category = 'contact media';
    }

    const inputNodeName = input.nodeName.toLowerCase();
    if (category) {
      if (inputNodeName == 'select') {
        dataLayer.push({
          "event": "contentInteraction",
          "interaction": {
            "category": category,
            "action": "fill information",
            "label": input.parentElement.previousElementSibling.textContent.toLowerCase()
          }
        });
      } else if (inputNodeName == 'textarea') {
        dataLayer.push({
          "event": "contentInteraction",
          "interaction": {
            "category": category,
            "action": "fill information",
            "label": input.parentElement.previousElementSibling.textContent.toLowerCase()
          }
        });
      } else if (inputNodeName == 'fieldset') {
        dataLayer.push({
          "event": "contentInteraction",
          "interaction": {
            "category": category,
            "action": "fill information",
            "label": input.querySelector('.fieldset-legend').textContent.toLowerCase()
          }
        });
      } else {
        dataLayer.push({
          "event": "contentInteraction",
          "interaction": {
            "category": category,
            "action": "fill information",
            "label": input.previousElementSibling.textContent.toLowerCase()
          }
        });
      }

    }
  }

  checkForCompletedItems() {
    this.formItem.forEach(i => {
      var inputTxt = i.querySelector('input[type="text"],input[type="email"],textarea');
      if (inputTxt) {
        i.classList.remove("focus");
        if (inputTxt.value != "") {
          i.classList.add("completed");
        } else {
          i.classList.remove("completed");
        }
      }
    });
  }

}
